import { FC } from "react"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"

export interface InfoProps {
   headerText?: string
   contentText?: string
   itemName?: string
   icon?: IconProps["name"]
}

const Info: FC<InfoProps> = ({
   headerText,
   contentText,
   itemName,
   icon = "trashBin",
}) => {
   return (
      <div className="delete-confirmation-modal__info">
         <div className="delete-confirmation-modal__info-header">
            <Icon
               name={icon}
               size="24"
               color={IconColor.WHITE}
            />
            {headerText && (
               <span className="delete-confirmation-modal__info-header-text">
                  {headerText}
               </span>
            )}
         </div>
         {contentText && (
            <div className="delete-confirmation-modal__info-description">
               {contentText}
               {itemName && (
                  <div className="delete-confirmation-modal__info-item-name">
                     {itemName}
                  </div>
               )}
            </div>
         )}
      </div>
   )
}

export default Info
